<template>
	<div class="gp-information">
		<div class="gp-layer-body">
			<div class="gp-row gp-row-center padding-bottom-0">
				<div class="gp-row-label"></div>
				<div class="gp-row-title">基础信息</div>
			</div>
			<div class="gp-section">
				<div class="gp-row">
					<div class="gp-option-title">品牌Logo</div>
					<div class="gp-option-value">
						<img :src="info.logo" class="logo" />
					</div>
				</div>

				<div class="gp-row">
					<div class="gp-option-title">品牌名称</div>
					<div class="gp-option-value">{{info.simple_name}}</div>
				</div>

				<div class="gp-row">
					<div class="gp-option-title">主体全称</div>
					<div class="gp-option-value">{{info.full_name}}</div>
				</div>

				<div class="gp-row">
					<div class="gp-option-title">品牌简介</div>
					<div id="brand_business_scope" class="gp-option-value">
						<el-input style="width: 318px;" type="textarea" placeholder="简单介绍一下品牌就可以哦～"
							v-model="info.business_scope" maxlength="120" rows="4" show-word-limit>
						</el-input>
					</div>
				</div>
				
				<div class="gp-row">
					<div class="gp-option-title gp-option-cover">
						<div class="gp-option-cover-xing">*</div>
						品牌封面
					</div>
					<div class="gp-option-value">
						<el-upload
						  class="upload-video"
						  v-loading="loading"
						  ref="upload_img"
						  :show-file-list="false"
						  :headers="upload.headers"
						  :action="upload.url"
						  :on-success="getfile"
						  :multiple="false"
						  :before-upload="beforeAvatarUpload"
						  :on-progress="onthecross"
						  >
						  <img class="cover_img" v-if="imginfo.id>0" :src="imginfo.url" alt="" />
							<div v-if="imginfo.id==0" class="uploader-div">
								<i class="el-icon-plus"></i>
							</div>
							<i v-if="imginfo.id>0" class="el-icon-error gp-product_del" @click.stop="clearImgPath"></i>
						</el-upload>
						<div class="gp-label-tip">建议尺寸800*450px，最大不超过2M</div>
					</div>
				</div>
				
				<div class="gp-row">
					<div class="gp-option-title">品牌视频</div>
					<div class="gp-option-value">
						<el-upload class="upload-video"
						  v-loading="videoFlag"
						  element-loading-text="视频上传中"
						  action=""
						  :disabled="videoPath != ''"
						  :http-request="fnUploadRequest"
						  :show-file-list="false"
						  :before-upload="beforeUploadVideo"
						  >
							<video v-if="videoPath && !videoFlag" :src="videoPath" class="player-div" controls="controls">
								您的浏览器不支持视频播放
							</video>
							<div v-else-if="!videoPath && !videoFlag" class="uploader-div">
								<i class="el-icon-plus"></i>
							</div>
							<i v-if="videoPath && !videoFlag" class="el-icon-error gp-product_del" @click.stop="clearVideoPath"></i>
						</el-upload>
						<div class="gp-label-tip">建议视频比例16:9，时长需控制在3分钟内，最大不超过100M</div>
					</div>
				</div>
			</div>

			<div class="gp-row gp-row-center">
				<div class="gp-row-label"></div>
				<div class="gp-row-title">品牌介绍</div>
			</div>
			<div class="gp-section">
				<quill-editor ref="text" v-model="content" placeholder="请输入品牌介绍" :options="editorOption">
				</quill-editor>
			</div>

			<div class="gp-section margin-top-95">
				<el-button type="primary" class="btn-save" @click="save">保存</el-button>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	import {
		getBrandInfo,
		saveBrandInfo
	} from '@/api/index';
	import {
		handleCode
	} from '@/utils/request';
	import {
		format_richtext__img,
		format_richtext__trim
	} from '@/utils/formater';
	import oss from '@/utils/oss';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor';
	import {
		container,
		ImageExtend,
		QuillWatch
	} from 'quill-image-extend-module';
	Quill.register('modules/ImageExtend', ImageExtend);
	export default {
		data() {
			return {
				info: {},
				content: '', //富文本内容
				products: [], //主打商品
				// ======= 视频上传
				videoId: 0,
				videoCover: 0,
				videoPath: '',
				videoFlag: false,//是否显示进度条
				// =======
				imginfo:{
				   id:0,
				   url:''
				},
				loading:false,
				// 照片墙
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] : ''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
				editorOption: {
					placeholder: '请输入品牌介绍',
					modules: {
						ImageExtend: {
							loading: true,
							name: 'file', //图片参数名
							size: 1, //可选参数 图片大小，单位为M，1M = 1024kb
							action: baseURL + '/api/brand.Upload/oneToOss', //上传的服务器地址，如果action为空，则采用base64插入图片
							accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg',
							// response 为一个函数，用来获取服务器返回的具体图片地址
							response: res => {
								return res.data.url;
							},
							headers: xhr => {
								// 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
								xhr.setRequestHeader("authorization", this.$store.getters['user/accessToken'])
							},
							// 可选参数 设置请求头部
							sizeError: (val) => {
								this.$message.error('请上传1MB以内的图片');
							}, // 图片超过大小的回调
							start: () => {}, // 可选参数 自定义开始上传触发事件
							end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
							error: () => {}, // 可选参数 上传失败触发的事件
							success: () => {
								var qr = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("img");
								for (var i = 0; i < qr.length; i++) {
									qr[i].style.width = '100%';
									qr[i].style.display = 'block';
								}
							}, // 可选参数  上传成功触发的事件
							change: (xhr, formData) => {
								// xhr.setRequestHeader('myHeader','myValue')
								// formData.append('token', 'myToken')
							} // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
						},
						toolbar: {
							// container为工具栏，此次引入了全部工具栏，也可自行配置
							container: [
								["bold", "italic", "underline", "strike"],
								["blockquote", "code-block"],
								[{ header: 1 }, { header: 2 }],
								[{ list: "ordered" }, { list: "bullet" }],
								[{ script: "sub" }, { script: "super" }],
								[{ indent: "-1" }, { indent: "+1" }],
								[{ direction: "rtl" }],
								[{ size: ["small", false, "large", "huge"] }],
								[{ header: [1, 2, 3, 4, 5, 6, false] }],
								[{ color: [] }, { background: [] }],
								[{ font: [] }],
								[{ align: [] }],
								["image"]
							],
							// 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
							handlers: {
								image: function() {
									// 劫持原来的图片点击按钮事件
									QuillWatch.emit(this.quill.id)
								}
							}
						}
					},
				},
				uploadOption: {
					action: baseURL + '/api/brand.Upload/oneToOss',
					headers: {
						authorization: this.$store.getters['user/accessToken']
					}
				}
			}
		},
		components: {
			quillEditor
		},
		created() {
			let head = document.getElementsByTagName('head');
			let meta = document.createElement('meta');
			meta.name = 'referrer';
			//根据实际情况修改referrer的值，可选值参考上文
			meta.content = 'no-referrer';
			head[0].appendChild(meta);
			this.getInfo();
		},
		mounted() {
			document.getElementsByClassName("ql-editor")[0].style.minHeight = "200px";
			document.getElementsByClassName("ql-editor")[0].style.maxHeight = "600px";
			
			document.getElementsByClassName("el-input__count")[0].style.bottom = "2px";
			document.getElementsByClassName("el-input__count")[0].style.right = "-50px";
		},
		updated() {
			var qr = document.getElementsByClassName("ql-editor")[0].getElementsByTagName("img");
			for (var i = 0; i < qr.length; i++) {
				qr[i].style.display = 'block';
			}
		},
		methods: {
			/**
			 * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
			 * @params {object} option [上传选项]
			 * @return {null} [没有返回]
			 */
			async fnUploadRequest(option) {
				oss.ossUploadFile(option).then((res) => {
					if (res.errcode === 0) {
						this.videoFlag = false;
						if (res.data.code == 0) {
							this.videoId = res.data.data.video_id ? res.data.data.video_id : 0;
							this.videoCover = res.data.data.video_cover ? res.data.data.video_cover : 0;
							this.videoPath = res.data.data.video_url ? res.data.data.video_url : 0;
						} else {
							this.$message.error("上传失败");
						}
					} else {
						this.$message.error(res.errmsg);
					}
				});
			},
			//视频上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 100;
				if (['video/mp4', 'video/3gp', 'video/m3u8'].indexOf(file.type) === -1) {
					this.$message.error("视频格式仅支持：mp4，3gp，m3u8");
					return false;
				}
				if (!fileSize) {
					this.$message.error("视频大小不能超过100MB");
					return false;
				}
				this.videoFlag = true;
			},
			//清除封面图
			clearImgPath() {
				this.imginfo={
				   id:0,
				   url:''
				};
			},
			//清除视频
			clearVideoPath() {
				this.videoId = 0;
				this.videoCover = 0;
				this.videoPath = '';
				this.videoFlag = false;
			},
			// ==================
			req_data(index) {
				return {
					index: index
				}
			},
			save() {
				if(this.imginfo.id==0){
					this.$message.error('请上传封面图');
					return false;
				}
				var products = this.products;
				for (var i = 0; i < products.length; i++) {
					if (products[i].name.trim().length == 0) {
						this.$message.error('主打商品有未填写的商品名称');
						return false;
					}
					if (products[i].img == 0) {
						this.$message.error('主打商品有未上传的商品封面');
						return false;
					}
				}
				this.saveInfo();
			},
			onthecross(){
				this.loading = true;
			},
			beforeAvatarUpload(file) {
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}
			},
			getfile(response, file){
				this.loading = false;
			    if(response.code == noPermissionCode){
				    handleCode(response.code,response.message);
			    }else if(response.code==40000){
					this.$message.error(response.message);
				}else{
				    var data = {id: response.data.id, url: response.data.url};
					this.imginfo = data;
				}
			    this.$refs.upload_img.clearFiles(); //上传成功之后清除历史记录
			},
			getInfo() {
				getBrandInfo({}).then(res => {
					if (res.code == 0) {
						var resdata = res.data;
						this.info = resdata;
						this.content =resdata.detail;
						this.products = resdata.product_desc;
						this.videoId = resdata.video_id ? resdata.video_id : 0;
						this.imginfo.id = resdata.video_cover ? resdata.video_cover : 0;
						this.imginfo.url = resdata.video_cover_path ? resdata.video_cover_path : 0;
						this.videoPath = resdata.video_path ? resdata.video_path : '';
					} else {
						this.$message.error(res.message);
					}
				})
			},
			saveInfo() {
				var business_scope = this.info.business_scope;
				var detail = this.content ? format_richtext__trim(format_richtext__img(this.content)) : '';
				var video_id = this.videoId;
				var cover_id = this.imginfo.id;
				var products = [];
				// this.products.forEach(function(item, index) {
				// 	products.push({
				// 		name: item.name,
				// 		desc: item.desc,
				// 		img: item.img,
				// 		path: item.path
				// 	})
				// })
				saveBrandInfo({
					business_scope: business_scope,
					detail: detail,
					video_id: video_id,
					video_cover: cover_id,
					product_desc: JSON.stringify(products),
				}).then(res => {
					if (res.code == 0) {
						this.$message.success('保存成功');
					} else {
						this.$message.error(res.message);
					}
				})
			},
			uploadBefore(file) {
				const limit_file_type = ["image/jpeg", "image/png", "image/gif"]; // 检测文件格式
				if (limit_file_type.indexOf(file.type) === -1) {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}

				const limit_file_size = 2 * 1024 * 1024; // 检测文件大小
				if (file.size > limit_file_size) {
					this.$message.error('上传图片大小不能超过 1MB!');
					return false;
				}
			},
			uploadSuccess(res, file) {
				if (res.code == noPermissionCode) {
					handleCode(res.code, res.message);
				} else {
					var index = res.data.req_data.index;
					if (this.products[index]) {
						this.products[index].img = res.data.id;
						this.products[index].path = res.data.url;
					}
				}
			},
			addProduct() {
				if (this.products.length < 6) {
					this.products.push({
						name: '',
						desc: '',
						img: 0,
						path: '',
					})
				}
			},
			delProduct(index) {
				if (this.products.length > 0) {
					this.products.splice(index, 1);
				}
			},
			delProductImg(index) {
				this.products[index].img = 0;
				this.products[index].path = '';
			},
		}
	};
</script>

<style scoped>
	.cover_img{
		width: 300px;
		height: 169px;
		object-fit:cover;
	}
	.gp-option-cover{
		position: relative;
	}
	.gp-option-cover-xing{
		position: absolute;
		z-index: 1;
		left: -10px;
		top: 0;
		height: 100%;
		line-height: 24px;
		color: #F56C6C;
		margin-right: 4px;
	}
	.quill-editor {
		width: 600px;
	}

	.gp-layer-body {
		min-height: 1230px;
		background: #FFFFFF;
		border-radius: 4px;
		border-top: 1px solid #EEEEEE;
	}
	
	.gp-section {
		padding: 15px 50px;
	}

	.gp-row {
		width: 100%;
		padding: 15px 0;
		display: flex;
		align-items: flex-start;
	}

	.gp-row-center {
		align-items: center;
	}

	.gp-row-label {
		width: 3px;
		height: 25px;
		margin-right: 15px;
		background: #409EFF;
	}

	.gp-row-title {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}

	.gp-row-value {
		width: 200px;
	}

	.gp_input {
		width: 100%;
		height: 40px;
	}

	.gp-option-title {
		width: 71px;
		margin-right: 25px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}

	.gp-option-value {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}

	.gp-option-value .el-textarea {
		padding: 0;
	}
	
	.gp-label-tip {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	
	.upload-video {
		position: relative;
		width: 300px;
		height: 169px;
		display: flex;
		justify-content: center;
		background: #F2F6FC;
		border-radius: 4px;
	}
	.player-div {
		width: 300px;
		height: 169px;
	}
	.uploader-div {
		width: 300px;
		height: 169px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.uploader-div .el-icon-plus {
		color: #429FFF;
		font-size: 35px;
		font-weight: bold;
	}

	.logo {
		width: 90px;
		height: 90px;
		border-radius: 4px;
		object-fit: cover;
	}

	.gp-product {
		position: relative;
		width: 367px;
		height: 122px;
		padding: 15px;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border-radius: 2px;
		border: 1px solid #DCDFE6;
		box-sizing: border-box;
	}

	.gp-product_img {
		position: relative;
		width: 90px;
		min-width: 90px;
		height: 90px;
	}

	.gp-product_cover {
		width: 90px;
		height: 90px;
		object-fit: cover;
		border-radius: 4px;
	}

	.gp-product_img_del {
		position: absolute;
		bottom: 0;
		z-index: 9;
		width: 90px;
		height: 23px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 23px;
		text-align: center;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 0 0 4px 4px;
	}

	.gp-product_info {
		width: 100%;
		margin-left: 10px;
	}

	.gp-product_title {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
	}

	.gp-product_tip {
		margin-top: 13px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}

	.gp-product_del {
		position: absolute;
		right: -7px;
		top: -7px;
		color: #999999;
		z-index: 9999;
	}
	
	.add_product {
		display: inline-block;
		line-height: 1;
		white-space: nowrap;
		cursor: pointer;
		background: #FFF;
		border: 1px solid #DCDFE6;
		color: #606266;
		-webkit-appearance: none;
		text-align: center;
		box-sizing: border-box;
		outline: 0;
		margin: 0;
		transition: .1s;
		font-weight: 500;
		padding: 12px 20px;
		font-size: 14px;
		border-radius: 4px;
		
		color: #409EFF;
		background: #ecf5ff;
		border-color: #b3d8ff;
	}
	
	.add_product:hover {
		color: #FFF;
		background: #409EFF;
		border-color: #409EFF;
	}

	.btn-save {
		width: 110px;
		letter-spacing: 1px;
	}

	.margin-top-30 {
		padding-top: 30px;
	}

	.margin-top-20 {
		margin-top: 20px;
	}

	.margin-top-80 {
		margin-top: 80px;
	}
	
	.margin-top-95 {
		margin-top: 95px;
	}

	.margin-left-5 {
		margin-left: 5px;
	}

	.margin-right-12 {
		margin-right: 12px;
	}

	.margin-left-120 {
		margin-left: 120px;
	}

	.padding-bottom-0 {
		padding-bottom: 0;
	}
</style>
